import React from 'react'
import PlayArrow from '@mui/icons-material/PlayArrow'
import styled from 'styled-components'

import Tooltip from 'components/Tooltip'

import { color } from 'styles/colors'

import Apptentive from 'helpers/apptentive'
import GA4 from 'helpers/ga4'
import { helpVideo } from 'helpers/help_videos'
import { screenSize } from 'styles/shared'

type Props = {
  videoKey: string
  className?: string
}

const HelpVideoLink = ({ videoKey, className = '' }: Props) => {
  const video = helpVideo(videoKey)
  const showLearnMore = (videoKey === 'drc_xxl' || videoKey === 'drc_link')

  const sendEvent = () => {
    const gAEvent = {
      category: 'Help Videos',
      action: showLearnMore ? 'Click Learn More DRC Video' : 'Click video icon',
      label: video.gaLabel
    }

    GA4.sendEvent(gAEvent)
    if (showLearnMore) {
      Apptentive.sendEvent('learn_more_drc_video_played')
    }
  }

  return (
    (showLearnMore
      ? (
        <S.LinkColumn className={className}>
          <S.LearnMorePlayIcon />

          <Tooltip title={video.tooltip} placement="top-start">
            <S.LearnMoreLink onClick={sendEvent} rel="noopener noreferrer" href={video.url} target="_blank">Learn More</S.LearnMoreLink>
          </Tooltip>
        </S.LinkColumn>
      )
      : (
        <S.Container onClick={sendEvent} className={className} rel="noopener noreferrer" href={video.url} target="_blank" data-testid="play-arrow-link">
          <Tooltip title={video.tooltip} placement="top-start">
            <S.PlayIcon />
          </Tooltip>
        </S.Container>
      )
    )
  )
}

export default HelpVideoLink

const S = {
  Container: styled.a`
    height: 24px;
    margin-left: 10px;
  `,
  PlayIcon: styled(PlayArrow)`
    color: ${color('helpVideoLink')};
    margin-bottom: 1px;
    border: 1px solid ${color('helpVideoLink')};
    border-radius: 4px;
    width: 25px;
    height: 23px;
    background-color: ${color('iconBackground')};

    @media ${screenSize.small} {
          width: 17px;
          height: 18px;
        }
  `,
  LearnMorePlayIcon: styled(PlayArrow)`
    color: ${color('helpVideoLink')};
    border: 1px solid ${color('helpVideoLink')};
    border-radius: 4px;
    width: 15px;
    height: 15px;
  `,
  LearnMoreLink: styled.a`
    padding-top: 2px;
  `,
  LinkColumn: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
  `
}
